import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=2373f6ee&scoped=true&lang=pug"
import script from "./EventList.vue?vue&type=script&lang=ts"
export * from "./EventList.vue?vue&type=script&lang=ts"
import style0 from "./EventList.vue?vue&type=style&index=0&id=2373f6ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2373f6ee",
  null
  
)

export default component.exports